<template>
<div class="codelab-simulator" :class="shit$(`w:100%; h:100%; overflow:h;`)">
    <div class="codelab-simulator-container" :class="shit$(`w:100%; h:100%; flt:l; bgc:#272727;`)">
        <el-scrollbar ref="scrollBar">
        <div class="simulator-content" v-show="showSimulator">
            <div class="simulator-title">
                <span>{{$t("code-lab/component/robot-connect/play-button/observable.js_0")}}</span>
                <span class="tts-lang">
                    <el-select 
                    :value="ttsLangCode"
                    @change="setTTSLangCode"
                    class="select-tts-lang"
                    style="width: 80px;"
                    >
                        <el-option-group :label="$t('ttslang.select_simulator_tts_lang')">
                            <el-option v-for="langCode in ttsLangCodes" :key="langCode.value" :value="langCode.value" :label="$t(langCode.label)"></el-option>
                        </el-option-group>
                    </el-select>
                </span>
            </div>
            <div id="screen-container" :style="{height: screenHeight + 'px'}" :class="shit$(`bgc:#000000;`)">
                <Youtube  />
            </div>
            <div :class="shit$(`h:35px; lh:3; pl:20px; c:#c8c8c8; font:12px;`)">
                <span>Kebbi {{$t("status")}} </span>
                <span>{{ kibie }}</span>
            </div>
            <div :class="shit$(`relative;`)">
                <div id="robot-container" :class="shit$(`w:100%; h:235px;`)"></div>
                <multimedia-container @kibieEmit="kibieEmit" :scene="scene" v-if="scene && simulatorInitStatus" />
            </div>
            <div :class="['trigger-menue',shit$(`bgc:#272727; relative;`)]">
                <trigger-menu @kibieEmit="kibieEmit" />
            </div>
            <transition-group name="fade">
                <div v-if="simulatorInitStatus === false" class="simulator-mask failed-mask" :key="1">
                    <div class="message">
                        {{$t("message.error_simulator_load")}}<span class="codelab-button blue retry" @click="reInitMachine">{{$t("button.retry")}}</span>
                    </div>
                </div>
                <div v-if="initingSimulator" class="simulator-mask tip-mask" :key="2">
                    <div class="message">
                        {{$t("message.info_simulator_loading")}}
                    </div>
                </div>
                <div v-if="loadingMeidas" class="simulator-tip" :style="{height: screenHeight + 'px'}" :key="3">
                    <div class="message-container">
                        <div class="message">
                            {{loadingMediaTip}}
                        </div>
                    </div>
                </div>
                <div v-if="loadingMediaFailed" class="simulator-tip" :style="{height: screenHeight + 'px'}" :key="4">
                    <div class="message-container">
                        <div class="message">
                            {{loadErrorMessage}}
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
        </el-scrollbar>
    </div>
</div>
</template>

<script>

import TriggerMenu from '@/code-lab/component/machine-simulator/trigger-menu.vue';
import MultimediaContainer from "./multimedia-control.vue";

import { mapState } from 'vuex';

const robot_xml_base_url = process.env.VUE_APP_robot_xml_base_url;
// const robot_xml_base_url = process.env.BASE_URL + "static/xml/";

const robot_mesh_base_url = ""+ process.env.BASE_URL +"static/mesh/";
const raw_base_url = process.env.VUE_APP_raw_base_url;
const motion_base_url = process.env.VUE_APP_motion_base_url;
const video_base_url = process.env.VUE_APP_video_base_url;
const apiKey = process.env.VUE_APP_api_key;
const env = process.env.VUE_APP_mode;
const checkMediaPath = process.env.BASE_URL + "static/simulator-media/";
import { store as exchangeStore } from '@/code-lab/component/exchange/observable.js'
import Youtube from '@/code-lab/component/youtube.js'
import YoutubeHandler from '@/service/tool/youtubeHandler.js'
const Cookies = window.Cookies;
export default {
    data: () => ({
        scene: null,
        simulator: null,
        kibie: '',
        simulatorStatus: 1,
        ttsLangCodes: [
            {label: "ttslang.chinese", value: "zh-CN"},
            {label: "ttslang.english", value: "en-US"},
            {label: "ttslang.japanese", value: "ja-JP"},
            {label: "ttslang.korean", value: "ko-KR"}
        ],
        screenHeight: 200,
        initingSimulator: false,
        loadingMediaTip: "",
        loadErrorMessage: "",
        loadingMeidas: false,
        loadingMediaFailed: false
    }),
    components: {
        TriggerMenu,
        MultimediaContainer,
        Youtube
    },
    computed: {
        simulatorKey: () => exchangeStore.simulator.keys[0],
        ...mapState('user', [
            'teamId',
            'token'
        ]),
        ...mapState({
            $baseUrl: "env$",
            showSimulator: 'showSimulator',
            selectedMenue: 'selectedMenue',
            currentVersion: "currentVersion",
            ttsLangCode: "ttsLangCode",
            simulatorInitStatus: 'simulatorInitStatus'
        }),
    },
    created(){
        this.$nextTick(() => {
            this.setTTSLangCode();
        });
    },
    mounted(){
        this.$nextTick(() => {
            window.addEventListener("resize", this.onResize);
        })
    },
    methods: {
        getApiKey () {
            return this.currentVersion === 'family' ? this.simulatorKey : apiKey
        },
        initMachine () {
            this.initingSimulator = true;
            this.$store.commit('simulatorInitStatus', null)
            this.$nextTick(async () => {
                var container = document.querySelector("#robot-container");
                var screen = document.querySelector("#screen-container");
                this.screenHeight = screen.clientWidth * 720 / 1280;
                screen.style.height = this.screenHeight + "px";
                var sessionToken =  this.b$.tool.store ? (this.b$.tool.store.sessionToken || "") : "";
                try {
                    // this.scene = new RobotSimulatorController(container, {
                    this.scene = new window.nuwa.RobotSimulator(container, {
                        apiKey: this.getApiKey(),
                        token: this.token,
                        customerId: this.teamId,
                        sessionToken,
                        env,
                        version: this.currentVersion,
                        pixel_ratio: window.devicePixelRatio,
                        control: true,
                        screen: screen,
                        floorIndex: 7,
                        robot_xml_base_url,
                        robot_mesh_base_url,
                        raw_base_url,
                        motion_base_url,
                        video_base_url,
                        checkMediaPath,
                        random_motion_base: `${this.$baseUrl}static/js/blockly/media/nuwa/random_motions/`
                    }, isInited => {
                        this.$store.commit('simulatorInitStatus', isInited)
                        this.initingSimulator = false;
                        isInited && this.yt()
                    });
                    this.scene.onmessage = this.onSimulatorMessage;
                    this.simulator = this.scene.simulator;
                    this.api = this.scene.api;
                    this.$root.simulator = this.scene;
                    this.simulatorStatus = this.api.status;
                } catch(err){
                    console.log("simulator init failed:", err);
                    this.$store.commit('simulatorInitStatus', false)
                    this.initingSimulator = false;
                }
            })
        },
        yt () {
            this.$nextTick(async () => {
                console.log('init yt iframe')
                await YoutubeHandler.initYoutubeApi()
                YoutubeHandler.creatScreenIframe()
                YoutubeHandler.creatRobotIframe()
                console.log( document.getElementById('youtubeScreenIframeWrapperId') )
                YoutubeHandler.appendToScreen()
                await YoutubeHandler.appendToRobot(this.api.$s)
                this.api.$s.scene.remove(this.api.$s.plane)
                this.scene.onResize();
                this.api.$s.startRenderLoop()
            })
        },
        reInitMachine(){
            if(this.simulator){
                this.simulator.destroy();
            }
            this.$nextTick(() => {
                this.initMachine();
            })
        },
        resetRobotPosition () {
            this.scene.api.resetPosition()
        },
        
        kibieEmit (msg) {
            this['kibie'] = this.$t(msg.name);
            if (msg.key === "listen") {
                this['kibie'] += ": " + (msg.content || "")
            } else if(msg.key === "touch"){
                this.kibie = this.$t("been") + this.kibie;
            } else if(msg.key === "see"){
                this.kibie += (": " + (msg.label || ""));
            } else if(msg.key === "recognize"){
                this.kibie += (": " + (msg.label || ""));
            }
            if(msg && msg.actionName){
                this.scene.api.fireNuwaEvent(msg.actionName, msg.data)
            }
        },
        setTTSLangCode(value){
            let langCode;
            if(value !== undefined){
                langCode = value;
            } else {
                langCode = Cookies.get("langCode");
                if(/zh/.test(langCode)){
                    langCode = "zh-CN";
                }
            }
            
            this.$store.commit("SET_TTS_LANG_CODE", langCode);
        },
        onSimulatorMessage(msg){
            if(msg.message === "loading_media"){
                this.loadingMeidas = true;
                this.loadingMediaTip = this.$t("message.info_medias_loading");
                if(msg.percent){
                    this.loadingMediaTip += msg.percent; 
                }
            } else if(msg.message === "load_media_failed"){
                this.loadingMeidas = false;
                this.loadingMediaFailed = true;
                if(msg.materialIndex){
                    this.loadErrorMessage = this.$t("message.warn_check_material_valide", {neme: msg.materialIndex});
                } else {
                    this.loadErrorMessage = this.$t("message.error_load_medias");
                }
                setTimeout(() => {
                    this.loadingMediaFailed = false;
                }, 5000);
            } else if(msg.message === "load_media_success"){
                this.loadingMeidas = false;
                this.loadingMediaFailed = false;
            }
        },
        onResize(){
            this.$nextTick(() => {
                if(this.$refs.scrollBar && this.$refs.scrollBar.update){
                    this.$refs.scrollBar.update();
                }
            });
        }
    },
    watch: {
        showSimulator (value) {
            if (value) {
                if (!this.simulator) {
                    this.initMachine();
                } else {
                    this.$nextTick(() => {
                        this.scene && this.scene.onResize();
                        
                    });
                }
            }
            this.$nextTick(() => {
                this.onResize();
            });
        },
    },
    destroyed () {
        if(this.scene){
            this.scene.destroy();
        }
        this.scene = null;
        this.simulator = null;
        window.removeEventListener("resize", this.onResize);
    },
};
</script>

<style lang="scss">
    .codelab-simulator{
        overflow: auto;
        .codelab-simulator-container{
            // overflow-y: auto;
            .simulator-content{
                width: 100%;
                // height: 100%;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                &>div{
                    width: 100%;
                    overflow: hidden;
                    flex: 0 0 auto;
                }
                &>.trigger-menue{
                    flex: 1 1 auto;
                    // overflow-y: auto;
                }
                .simulator-title{
                    width: 100%;
                    height: 35px;
                    padding: 0 14px;
                    line-height: 35px;
                    font-size: 14px;
                    position: relative;
                    color: $--codelab-primary-gray-2;
                    .simulator-title{
                        float: left;
                    }
                    .tts-lang{
                        font-size: 12px;
                        float: right;
                        .select-tts-lang{
                            transform-origin: center center;
                            transform: scale(0.8);
                            .el-input{
                                .el-input__inner{
                                    background: #333333;
                                    padding: 0 6px;
                                }
                            }
                        }
                    }
                }
            }
        }
        #robot-container{ 
            iframe {
                border-width: 0px;
            }
        }
        .simulator-mask{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: #333333;
            color: #a8a8ac;
            text-align: center;
            z-index: 1;
            &.failed-mask{
                color: red;
            }
            &.tip-mask{
                background: rgba(0,0,0,0.8);
            }
            .message{
                width: 100%;
                height: 96px;
                padding: 0 48px;
                line-height: 32px;
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -48px;
                .retry{
                    border-radius: 14px;
                    display: inline-block;
                    margin-left: 14px;
                    vertical-align: middle;
                    font-size: 15px;
                    padding: 0 14px;
                    line-height: 28px;
                }
            }
            
        }
        .simulator-tip{
            width: 100%;
            position: absolute;
            left: 0;
            top: 35px;
            text-align: center;
            .message-container{
                width: 100%;
                position: absolute;
                bottom: 32px;
                left: 0;
                .message{
                    display: inline-block;
                    max-width: 90%;
                    font-size: 13px;
                    padding: 14px 24px;
                    line-height: 24px;
                    border-radius: 8px;
                    background: rgba(0,0,0,0.8);
                    color: #ffffff;
                }
            }
        }
        .el-scrollbar{
            &:hover{
                .el-scrollbar__bar{
                    opacity: 1;
                }
            }
            .el-scrollbar__bar{
                opacity: 0.3;
                .el-scrollbar__thumb{
                    background: #666666;
                }
            }
        }
    }
    // #ytplayer { pointer-events: none; }
</style>
